import { render, staticRenderFns } from "./picCompoents.vue?vue&type=template&id=320879ec&scoped=true&"
import script from "./picCompoents.vue?vue&type=script&lang=js&"
export * from "./picCompoents.vue?vue&type=script&lang=js&"
import style0 from "./picCompoents.vue?vue&type=style&index=0&id=320879ec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320879ec",
  null
  
)

export default component.exports